import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("mb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      localStorage.removeItem("mb_token");
      window.location.href = "/login";
    }
    const cfg = err.config || {};
    const transient = !err.response || [502,503,504].includes(err.response?.status);
    if (transient && String(cfg.method||"get").toLowerCase()==="get" && !cfg.__mbRetried) {
      cfg.__mbRetried = true;
      await new Promise(resolve=>setTimeout(resolve,650));
      return API(cfg);
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return err.message || "Something went wrong.";
}
